import { render, staticRenderFns } from "./channels.vue?vue&type=template&id=206eb714&"
import script from "./channels.vue?vue&type=script&lang=ts&"
export * from "./channels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports